//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CheckPrice',
  components: {},
  props: {
    pdmPricingWorkingProcedureVo: {
      type: Object,
      required: true,
      default: null
    }
  },
  data: function data() {
    return {
      styleColorActive: '0'
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};